import { Linking, Pressable, StyleSheet, Text } from "react-native";

import { colors } from "@/constants/colors";

interface DisplayDescriptionProps {
  description: string;
  editable: boolean;
  onPress: () => void;
  vScale: number;
}

type ParsedSegment =
  | { text: string; type: "link"; url: string }
  | { text: string; type: "text" };

export default function DisplayDescription({
  description,
  editable,
  onPress,
  vScale,
}: DisplayDescriptionProps) {
  const segments = parseMarkdown(description);

  return (
    <Pressable disabled={!editable} onPress={onPress}>
      <Text
        style={[
          styles.description,
          {
            color: !description ? colors.white : colors.light,
            fontSize: 15 * vScale,
            lineHeight: 22 * vScale,
          },
        ]}
      >
        {description
          ? segments.map((segment, index) =>
              segment.type === "link" ? (
                <Text
                  key={index}
                  onPress={() => {
                    if (editable) {
                      onPress();
                    } else {
                      Linking.openURL(segment.url);
                    }
                  }}
                  style={styles.link}
                >
                  {segment.text}
                </Text>
              ) : (
                segment.text
              ),
            )
          : "+ add description"}
      </Text>
    </Pressable>
  );
}

function parseMarkdown(markdown: string): ParsedSegment[] {
  const pattern = /\[([^\]]+)\]\(([^)]+)\)|(https?:\/\/[^\s)]+)/g;
  const segments: ParsedSegment[] = [];
  let lastIndex = 0;
  let match: null | RegExpExecArray;

  while ((match = pattern.exec(markdown)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        text: markdown.slice(lastIndex, match.index),
        type: "text",
      });
    }
    if (match[1] && match[2]) {
      segments.push({ text: match[1], type: "link", url: match[2] });
    } else if (match[3]) {
      segments.push({ text: match[3], type: "link", url: match[3] });
    }
    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < markdown.length) {
    segments.push({
      text: markdown.slice(lastIndex),
      type: "text",
    });
  }

  return segments;
}

const styles = StyleSheet.create({
  description: {
    fontSize: 15,
    lineHeight: 22,
    textAlign: "left",
  },
  link: {
    color: colors.white,
    textDecorationLine: "underline",
  },
});
